module.exports = __webpack_public_path__ + "media/globe.ffd350d6.mp4";